export default "__VITE_ASSET__CGdIjjpw__"